import { Middleware } from "redux";
import { socketActions } from "../socketSlice";
import IMessage from "../../models/message.model";
import { gameActions } from "../gameSlice";
import IPlayer from "../../models/player.model";
import { configActions } from "../configSlice";

const socketMiddleware: Middleware = (store) => {
  let socket: WebSocket;

  return (next) => (action) => {
    if (socketActions.connect.match(action)) {
      const payload: any = action.payload;
      socket = new WebSocket(
        `ws://${payload?.ip}:${
          payload?.port
        }`
      );

      socket.onmessage = function (event) {
        console.log(event.data);
        store.dispatch(socketActions.addIncomingMessage(event.data));
        const message: IMessage = JSON.parse(event.data);

        if (message.type === "playerList") {
          const pList: IPlayer[] = message.data;
          store.dispatch(
            gameActions.setPlayerList(
              pList.sort((p1, p2) => {
                return p1.name.localeCompare(p2.name);
              })
            )
          );
        } else if(message.type === "plotpolesChanged") {
          store.dispatch(gameActions.togglePlotpolesVisiblity(message.data));
        } else if(message.type === "vehiclesChanged") {
          store.dispatch(gameActions.toggleVehiclesVisiblity(message.data));
        } else if(message.type === "show_safesChanged") {
          store.dispatch(gameActions.toggleSafesVisiblity(message.data));
        } else if(message.type === "show_0000_safesChanged") {
          store.dispatch(gameActions.toggleZeroedSafesVisiblity(message.data));
        } else if(message.type === "backpacksChanged") {
          store.dispatch(gameActions.toggleBackpacksVisiblity(message.data));
        } else if(message.type === "dead_bodiesChanged") {
          store.dispatch(gameActions.toggleDeadBodiesVisiblity(message.data));
        } else if(message.type === "veinsChanged") {
          store.dispatch(gameActions.toggleVeinsVisiblity(message.data));
        }
      };

      socket.onopen = function () {
        store.dispatch(socketActions.setIsConnected(true));
        store.dispatch(configActions.setServerAddress(payload.ip));
        store.dispatch(configActions.setServerPort(payload.port));
      };

      socket.onclose = function () {
        store.dispatch(socketActions.setIsConnected(false));
        store.dispatch(gameActions.reset());
      };

      socket.onerror = function (e) {
        console.log(e);
      };
    } else if (socketActions.disconnect.match(action)) {
      if (socket.OPEN) {
        socket.close();
      }
    } else if (socketActions.sendMessage.match(action)) {
      if (socket.OPEN) {
        socket.send(action.payload);
      }
    }

    next(action);
  };
};

export default socketMiddleware;
